import withLazy from '../../hoc/with-lazy';
const BadgeLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-members-badge" */ './badge'),
    errorHandling: { type: 'HANDLE' },
});
export default BadgeLazy;
//# sourceMappingURL=badge-lazy.js.map